/** @jsxImportSource @emotion/react */

import { Box, useTheme } from '@mui/material'
import { css } from '@emotion/react'
import React, { ReactNode } from 'react'

interface SplashPageProps {
  children: ReactNode
}

interface SplashPageHeroProps {
  children: ReactNode
}

interface SplashPageContentProps {
  children: ReactNode
}

const SplashPageRoot: React.FC<SplashPageProps> = ({ children }) => {
  const containerStyles = css`
    display: flex;
    flex-direction: column;
    height: 100vh;
  `

  return <Box css={containerStyles}>{children}</Box>
}

const SplashPageHero: React.FC<SplashPageHeroProps> = ({ children }) => {
  const theme = useTheme()
  const topSectionStyles = css`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background-color: ${theme.palette.neutral.main};
  `

  const contentContainerStyles = css`
    width: 100%;
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
  `

  return (
    <Box css={topSectionStyles}>
      <Box css={contentContainerStyles}>{children}</Box>
    </Box>
  )
}

const SplashPageContent: React.FC<SplashPageContentProps> = ({ children }) => {
  const bottomSectionStyles = css`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: #f0f0f0;
  `

  const contentContainerStyles = css`
    width: 100%;
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
  `

  return (
    <Box css={bottomSectionStyles}>
      <Box css={contentContainerStyles}>{children}</Box>
    </Box>
  )
}

export const SplashPage = Object.assign(SplashPageRoot, {
  Hero: SplashPageHero,
  Content: SplashPageContent,
})
